import axios from "axios";
import { pv_data_variables, default_pv_data } from "../entities/pv_data";
import moment from "moment";
import { max_hours_update } from "../config";

import { api_url } from "../config";

const pv_data_convertion = {
	Fixed: 0,
	"1 axis": 1,
	"2 axis": 2
};

class ForecastService {
	async get_location_forecasts(location) {
		var pv_data = Object.assign({}, location.pv_data);
		var results = await this.get_forecasts(
			location.position[0],
			location.position[1],
			pv_data,
			location.pv_category
		);
		return results;
	}

	async get_forecasts(lat, lng, pv_data, pv_category) {
		let pv_data_interface = Object.assign({}, pv_data);

		//Convert tracking to Sentinel format
		pv_data_interface.tracking = pv_data_convertion[pv_data_interface.tracking];

		//Convert peak power from MW to KW
		pv_data_interface.peak_power = this.mw_to_kw(pv_data_interface.peak_power);

		let get_url =
			api_url +
			"/get-forecast/" +
			lat +
			"/" +
			lng +
			"?powerType=pv&peakPower=" +
			pv_data_interface.peak_power;

		for (var variable in pv_data_variables) {
			if (
				pv_data_interface.hasOwnProperty(variable) &&
				pv_data_interface[variable]
			) {
				get_url += "&" + variable + "=" + pv_data_interface[variable];
			} else if (default_pv_data[pv_category].hasOwnProperty(variable)) {
				get_url +=
					"&" + variable + "=" + default_pv_data[pv_category][variable];
			}
		}

		try {
			const response = await axios.get(get_url);
			if (response.status === 200) {
				return this.format_forecasts(response.data.data);
			} else throw new Error("Error downloading forecasts");
		} catch (error) {
			throw new Error("Error downloading forecasts");
		}
	}

	format_forecasts(forecasts) {
		var result = [];

		forecasts.hourly.forEach(forecast => {
			result.push({
				time: forecast.time * 1000,
				temperature: forecast.temperature,
				pv_power: this.kw_to_mw(forecast.pv) || 0
			});
		});
		return result;
	}

	async location_forecast_autodownload(location) {
		//If location's forecasts has to be downloaded download
		try {
			var data = {
				forecasts: null,
				updated: false
			};
			if (!this.check_location_auto_download(location)) {
				data.forecasts = this.check_location_forecasts(location.forecasts);
			} else {
				data.updated = true;
				data.forecasts = await this.get_location_forecasts(location);
			}
			return data;
		} catch (e) {
			return false;
		}
	}

	check_location_forecasts(forecasts) {
		const current_hour_timestamp = moment()
			.startOf("hour")
			.format("x");

		var filtered = forecasts.filter(function(value) {
			return value.time >= current_hour_timestamp;
		});

		return filtered;
	}

	check_location_auto_download(location) {
		//Check if location has been ever updated
		if (
			!location.hasOwnProperty("last_update") ||
			!location.hasOwnProperty("forecasts") ||
			location.forecasts.length == 0
		) {
			return true;
		}

		//Check if location's last update exceeded the maximum
		if (
			moment().diff(moment(location.last_update), "hours") >= max_hours_update
		) {
			return true;
		}

		//If the location has not to be updated
		return false;
	}

	kw_to_mw(kw) {
		return kw / 1000;
	}
	mw_to_kw(mw) {
		return mw * 1000;
	}
}
export default new ForecastService();
